/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { EmptyResponse } from '../models/empty-response';
import { scheduleControllerCreateSchedule } from '../fn/schedulazioni/schedule-controller-create-schedule';
import { ScheduleControllerCreateSchedule$Params } from '../fn/schedulazioni/schedule-controller-create-schedule';
import { scheduleControllerDeleteSchedule } from '../fn/schedulazioni/schedule-controller-delete-schedule';
import { ScheduleControllerDeleteSchedule$Params } from '../fn/schedulazioni/schedule-controller-delete-schedule';
import { scheduleControllerFindAllSchedules } from '../fn/schedulazioni/schedule-controller-find-all-schedules';
import { ScheduleControllerFindAllSchedules$Params } from '../fn/schedulazioni/schedule-controller-find-all-schedules';
import { scheduleControllerFindOneSchedule } from '../fn/schedulazioni/schedule-controller-find-one-schedule';
import { ScheduleControllerFindOneSchedule$Params } from '../fn/schedulazioni/schedule-controller-find-one-schedule';
import { scheduleControllerFindScheduleStatuses } from '../fn/schedulazioni/schedule-controller-find-schedule-statuses';
import { ScheduleControllerFindScheduleStatuses$Params } from '../fn/schedulazioni/schedule-controller-find-schedule-statuses';
import { scheduleControllerPreviewEmailBody } from '../fn/schedulazioni/schedule-controller-preview-email-body';
import { ScheduleControllerPreviewEmailBody$Params } from '../fn/schedulazioni/schedule-controller-preview-email-body';
import { scheduleControllerSendEmail } from '../fn/schedulazioni/schedule-controller-send-email';
import { ScheduleControllerSendEmail$Params } from '../fn/schedulazioni/schedule-controller-send-email';
import { scheduleControllerUpdateSchedule } from '../fn/schedulazioni/schedule-controller-update-schedule';
import { ScheduleControllerUpdateSchedule$Params } from '../fn/schedulazioni/schedule-controller-update-schedule';
import { ScheduleItem } from '../models/schedule-item';
import { StringItem } from '../models/string-item';
import { TicketScheduleResponse } from '../models/ticket-schedule-response';
import { TicketScheduleStatusesResponse } from '../models/ticket-schedule-statuses-response';

@Injectable({ providedIn: 'root' })
export class SchedulazioniService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scheduleControllerFindAllSchedules()` */
  static readonly ScheduleControllerFindAllSchedulesPath = '/schedule';

  /**
   * Restituisce le schedulazioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerFindAllSchedules()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindAllSchedules$Response(params?: ScheduleControllerFindAllSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketScheduleResponse;
}>> {
    return scheduleControllerFindAllSchedules(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le schedulazioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerFindAllSchedules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindAllSchedules(params?: ScheduleControllerFindAllSchedules$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketScheduleResponse;
}> {
    return this.scheduleControllerFindAllSchedules$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketScheduleResponse;
}>): BaseResponse & {
'data'?: TicketScheduleResponse;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerCreateSchedule()` */
  static readonly ScheduleControllerCreateSchedulePath = '/schedule';

  /**
   * Crea una schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerCreateSchedule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerCreateSchedule$Response(params: ScheduleControllerCreateSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>> {
    return scheduleControllerCreateSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerCreateSchedule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerCreateSchedule(params: ScheduleControllerCreateSchedule$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ScheduleItem;
}> {
    return this.scheduleControllerCreateSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>): BaseResponse & {
'data'?: ScheduleItem;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerFindScheduleStatuses()` */
  static readonly ScheduleControllerFindScheduleStatusesPath = '/schedule/status';

  /**
   * Restituisce gli stati delle schedulazioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerFindScheduleStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindScheduleStatuses$Response(params?: ScheduleControllerFindScheduleStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketScheduleStatusesResponse;
}>> {
    return scheduleControllerFindScheduleStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati delle schedulazioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerFindScheduleStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindScheduleStatuses(params?: ScheduleControllerFindScheduleStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketScheduleStatusesResponse;
}> {
    return this.scheduleControllerFindScheduleStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketScheduleStatusesResponse;
}>): BaseResponse & {
'data'?: TicketScheduleStatusesResponse;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerPreviewEmailBody()` */
  static readonly ScheduleControllerPreviewEmailBodyPath = '/schedule/{id}/preview-body';

  /**
   * Preview del body di una mail schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerPreviewEmailBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerPreviewEmailBody$Response(params: ScheduleControllerPreviewEmailBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return scheduleControllerPreviewEmailBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Preview del body di una mail schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerPreviewEmailBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerPreviewEmailBody(params: ScheduleControllerPreviewEmailBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.scheduleControllerPreviewEmailBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerSendEmail()` */
  static readonly ScheduleControllerSendEmailPath = '/schedule/{id}/send-email';

  /**
   * Invia una mail per una schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerSendEmail$Response(params: ScheduleControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return scheduleControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una mail per una schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerSendEmail(params: ScheduleControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.scheduleControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerFindOneSchedule()` */
  static readonly ScheduleControllerFindOneSchedulePath = '/schedule/{id}';

  /**
   * Restituisce una schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerFindOneSchedule()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindOneSchedule$Response(params: ScheduleControllerFindOneSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>> {
    return scheduleControllerFindOneSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerFindOneSchedule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerFindOneSchedule(params: ScheduleControllerFindOneSchedule$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ScheduleItem;
}> {
    return this.scheduleControllerFindOneSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>): BaseResponse & {
'data'?: ScheduleItem;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerDeleteSchedule()` */
  static readonly ScheduleControllerDeleteSchedulePath = '/schedule/{id}';

  /**
   * Cancella schedulazione tag ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerDeleteSchedule()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerDeleteSchedule$Response(params: ScheduleControllerDeleteSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return scheduleControllerDeleteSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancella schedulazione tag ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerDeleteSchedule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scheduleControllerDeleteSchedule(params: ScheduleControllerDeleteSchedule$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.scheduleControllerDeleteSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `scheduleControllerUpdateSchedule()` */
  static readonly ScheduleControllerUpdateSchedulePath = '/schedule/{id}';

  /**
   * Modifica una schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scheduleControllerUpdateSchedule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerUpdateSchedule$Response(params: ScheduleControllerUpdateSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>> {
    return scheduleControllerUpdateSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scheduleControllerUpdateSchedule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scheduleControllerUpdateSchedule(params: ScheduleControllerUpdateSchedule$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ScheduleItem;
}> {
    return this.scheduleControllerUpdateSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>): BaseResponse & {
'data'?: ScheduleItem;
} => r.body)
    );
  }

}
